// extracted by mini-css-extract-plugin
module.exports = {"title__marquee":"styles_title__marquee__2dkDJ","title__marquee__text":"styles_title__marquee__text__htaZb"};